import { Link } from 'react-router-dom';
import { Crown } from 'lucide-react';
import { usePaymentGate } from '../hooks/usePaymentGate';

/**
 * ─── QuotaBanner ─────────────────────────────────────────────────────────────
 *
 * Bandeau discret : informe l'utilisateur de ses essais restants du jour
 * AVANT qu'il ne se heurte au paywall. Piloté par les limites EFFECTIVES
 * (quota gratuit ou entitlements du plan de l'abonné) : seuls les types
 * réellement limités sont mentionnés. Ne rend RIEN si paiements OFF ou si
 * tout est illimité.
 */
export function QuotaBanner() {
  const { quota, isExpired, hasActiveSubscription, canPurchaseInApp } = usePaymentGate();
  if (!quota) return null;

  const parts: string[] = [];
  if (quota.practiceLimit !== null) {
    parts.push(
      `${quota.practiceRemaining}/${quota.practiceLimit} pratique${quota.practiceLimit > 1 ? 's' : ''}`,
    );
  }
  if (quota.simulationLimit !== null) {
    parts.push(
      `${quota.simulationRemaining}/${quota.simulationLimit} simulation${quota.simulationLimit > 1 ? 's' : ''}`,
    );
  }
  if (parts.length === 0) return null;

  const prefix = hasActiveSubscription
    ? 'Votre plan : '
    : isExpired
      ? 'Abonnement expiré — mode gratuit. '
      : 'Mode gratuit : ';

  return (
    <div className="flex items-center gap-3 bg-amber-100 dark:bg-amber-500/10 border border-amber-300 dark:border-amber-500/25 rounded-xl px-4 py-2.5 text-xs">
      <Crown className="w-4 h-4 text-amber-600 dark:text-amber-400 flex-shrink-0" />
      <p className="flex-1 text-amber-900 dark:text-amber-200/90 leading-snug">
        {prefix}il vous reste aujourd'hui <strong>{parts.join(' et ')}</strong>.
      </p>
      {!hasActiveSubscription && canPurchaseInApp && (
        <Link
          to="/plans"
          className="flex-shrink-0 font-semibold text-amber-700 hover:text-amber-800 dark:text-amber-300 dark:hover:text-amber-200 underline underline-offset-2"
        >
          {isExpired ? 'Renouveler' : 'Passer Premium'}
        </Link>
      )}
    </div>
  );
}
